import {
  Button,
  cn,
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
  Icon,
  RelativeDate,
  Spinner,
} from "@qw/ui";

import { formatChatSessionTitle } from "../chat.helpers";
import { useChatSession } from "../providers/chat-session-provider";

export const ChatSessionSelector = () => {
  const {
    canCreateChatSession,
    chatSession,
    chatSessions,
    chatSessionsLoading,
    createChatSessionLoading,
    handleCreateChatSession,
    setChatSession,
  } = useChatSession();

  const currentSessionTitle = chatSessions.find((session) => session.id === chatSession?.id)?.title;

  const label = currentSessionTitle
    ? formatChatSessionTitle(currentSessionTitle)
    : canCreateChatSession
      ? "New Chat Session"
      : "Chat Sessions";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button
          variant="ghost"
          size="sm"
          disabled={chatSessionsLoading || createChatSessionLoading}
          className="group max-w-full"
        >
          <span className="text-sm font-medium text-foreground truncate">{label}</span>
          {chatSessionsLoading || createChatSessionLoading ? (
            <Spinner />
          ) : (
            <Icon icon="keyboard_arrow_right" className="group-data-[state=open]:rotate-90 transition-transform" />
          )}
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="start">
        {canCreateChatSession ? (
          <>
            <DropdownMenuItem onClick={handleCreateChatSession}>
              <Icon icon="smart_toy" />
              <span className="text-sm font-medium">New Chat Session</span>
            </DropdownMenuItem>

            <DropdownMenuSeparator />
          </>
        ) : null}

        {chatSessions[0] ? (
          chatSessions.map((session) => {
            const ownerName = session.user
              ? `${session.user.firstName} ${session.user.lastName}`.trim() || session.userId
              : session.userId;

            return (
              <DropdownMenuItem
                key={session.id}
                className={cn(session.id === chatSession?.id && "text-primary! bg-accent")}
                onClick={() => setChatSession(session)}
              >
                <Icon icon="chat_bubble" />
                <div className="flex flex-col">
                  <span className="text-sm font-medium">
                    {session.title ? formatChatSessionTitle(session.title) : "Untitled Chat"}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {ownerName} &middot; <RelativeDate date={session.updatedAt || session.createdAt} />
                  </span>
                </div>
              </DropdownMenuItem>
            );
          })
        ) : (
          <DropdownMenuItem disabled>
            <Icon icon="help" />
            <span className="text-sm font-medium">No previous chat sessions found.</span>
          </DropdownMenuItem>
        )}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
